import React, { useEffect, useState } from 'react'
import imgEmployee from '../../../images/EmployeeBtn.svg'
import { Image } from 'react-bootstrap'
import { getRightMenuMainAPI } from '../../../services/right-menu'
import { useDispatch } from 'react-redux'
import imgEmployee2 from '../../../images/EmployeeBtn-disable.svg'
import { FcNext } from 'react-icons/fc'

function MenuRights({ openMenu2, openSubMenu3, setOpenSupMenu3, roleId }) {
  const [main, setMain] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    const getRightMenuMain = async () => {
      const param = { roleId }
      const res = await getRightMenuMainAPI(param)
      if (!res) return
      if (res.status) {
        setMain(res.result)
      }
    }

    if (roleId) {
      setClickedIndex3(null)
      getRightMenuMain()
    }
  }, [roleId])

  const [clickedIndex3, setClickedIndex3] = useState(null)

  const handleClickMenu = (m, i) => {
    setClickedIndex3(i)
    setOpenSupMenu3(i === clickedIndex3 ? !openSubMenu3 : true)
    dispatch({ type: 'SET_MENU_ID', payload: m.menu_id ?? '' })
  }
  return (
    <span className="col-2">
      {openMenu2 ? (
        <span className="">
          {main.map((m, i) => (
            <div
              className={`pt-2 pb-2 button-box  ${
                clickedIndex3 === i ? 'clicked' : ''
              }
              ${m.next ? 'pointer-event' : ''}
              `}
              key={i}
              onClick={() => handleClickMenu(m, i)}
            >
              <span className="d-flex gap-2 justify-content-between me-2">
                <span className="m-4 mt-0 mb-0 me-0">
                  {m.checked ? (
                    <>
                      <Image src={imgEmployee} />
                    </>
                  ) : (
                    <Image src={imgEmployee2} />
                  )}{' '}
                  <span className="mb-0 me-0 m-2">{m.menu_name}</span>
                </span>
                {/* <div className="d-flex "> */}
                <span>{m.next ? <FcNext /> : <></>}</span>
                {/* </div> */}
              </span>
            </div>
          ))}
        </span>
      ) : (
        <></>
      )}
    </span>
  )
}

export default MenuRights
